import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faSpinner, faExclamationTriangle, faUpload, } from "@fortawesome/pro-solid-svg-icons";
import { Button } from "@perfectserve/library";
export const ValidationStep = ({ isValidating, validationErrors, hasPassedValidation, validationCurrentRow, validationTotalRows, recordsCount, isValidationOnly, currentStep, onUploadNewFile, onContinue, rowClassName, }) => {
    const getIcon = () => {
        if (currentStep === "validation" && isValidating) {
            return _jsx(FontAwesomeIcon, { icon: faSpinner, spin: true });
        }
        if (validationErrors.length > 0) {
            return _jsx(FontAwesomeIcon, { icon: faExclamationTriangle });
        }
        if (hasPassedValidation) {
            return _jsx(FontAwesomeIcon, { icon: faCheckCircle });
        }
        return _jsx(FontAwesomeIcon, { icon: faUpload });
    };
    const getRightContent = () => {
        if (currentStep === "validation" && isValidating) {
            return (_jsxs("span", { children: ["Validating row ", validationCurrentRow, " of ", validationTotalRows, "..."] }));
        }
        if (validationErrors.length > 0) {
            return (_jsxs(_Fragment, { children: [_jsxs("span", { children: [validationErrors.length, " error", validationErrors.length !== 1 ? "s" : "", " found"] }), _jsx(Button, { variant: "secondary", size: "small", onClick: onUploadNewFile, children: "Upload New File" })] }));
        }
        if (hasPassedValidation) {
            return (_jsxs(_Fragment, { children: [_jsxs("span", { children: [recordsCount, " record", recordsCount !== 1 ? "s" : "", " valid"] }), isValidationOnly && currentStep === "validation" && (_jsx(Button, { variant: "primary", size: "small", onClick: onContinue, children: "Continue" }))] }));
        }
        return null;
    };
    return (_jsxs("div", { className: `auto-provisioning__workflow-row ${rowClassName}`, children: [_jsxs("div", { className: "auto-provisioning__row-left", children: [getIcon(), _jsx("span", { className: "auto-provisioning__row-label", children: "File Validation" })] }), _jsx("div", { className: "auto-provisioning__row-right", children: getRightContent() })] }));
};
